<template lang="pug">

  .sosSelectWrapper

    label.sosSelectTitle(v-if="!!label === true")

      span(v-html="`${label} <span class=\"vLabelDescription\">${labelDescription}</span>`" v-if="labelDescription")
      span(v-html="`${label}`" v-else)

    .sosSelectField(:class="{ 'sosSelectField--autoHeight': autoHeight }")

      .sosSelect(ref="sosSelect" @mousedown="event => openMouse(event)" @focusout="event => close(event)" :class="{ 'sosSelect--showing': show, 'sosSelect--disabled': disabled || !!validItems === false || (!!validItems === true && validItems.length === 0), 'sosSelect--fullScreen': fullscreen }" tabindex="0")

        .sosSelectSelected(v-html="selectedItemText")

        .sosSelectOptions(v-if="!!validItems === true && validItems.length > 0" ref="sosSelectOptions")

          template(v-if="fullscreen === true")

            .selector-options(:class="{ 'selector-options__auto': fullscreenAutoWidth }")

              .sosSelectFullscreenTitle(v-if="!!fullscreenTitle === true")

                .sosSelectFullscreenTitleText {{ fullscreenTitle }}

                .sosSelectFullscreenTitleClose
                  .sosSelectFullscreenCloseButton.mdi.mdi-close(@click="instantClosing")

              .options-inner

                .sosSelectOptionCheckedContainer(v-if="checkedItems.length > 0")
                  .sosSelectOption(v-for="(item, index) in checkedItems" :key="`chk_sos-select-item-${item.key}`" @mousedown="event => onSelectItem(event, item)" :class="{ 'mdi': multiple ? item.checked : (selectedItemValue === item.value), /* 'mdi-check': multiple ? item.checked : (selectedItemValue === item.value), */ 'sosSelectOption--selected': multiple ? item.checked : (selectedItemValue === item.value), 'sosSelectOption--disabled': !!item.disabled === true, 'sosSelectOption--first': index === 0 }" v-html="!!item.formattedText ? item.formattedText : (item.text || '&nbsp;')")

                template(v-if="nonCheckedItems.length > 0")
                  .sosSelectOption(v-for="(item, index) in nonCheckedItems" :key="`sos-select-item-${item.key}`" @mousedown="event => onSelectItem(event, item)" :class="{ 'mdi': multiple ? item.checked : (selectedItemValue === item.value), /* 'mdi-check': multiple ? item.checked : (selectedItemValue === item.value), */ 'sosSelectOption--selected': multiple ? item.checked : (selectedItemValue === item.value), 'sosSelectOption--disabled': !!item.disabled === true, 'sosSelectOption--first': index === 0 }" v-html="!!item.formattedText ? item.formattedText : (item.text || '&nbsp;')")

          template(v-else)

            .sosSelectOptionCheckedContainer(v-if="checkedItems.length > 0")
              .sosSelectOption(v-for="(item, index) in checkedItems" :key="`chk_sos-select-item-${item.key}`" @mousedown="event => onSelectItem(event, item)" :class="{ 'mdi': multiple ? item.checked : (selectedItemValue === item.value), /* 'mdi-check': multiple ? item.checked : (selectedItemValue === item.value), */ 'sosSelectOption--selected': multiple ? item.checked : (selectedItemValue === item.value), 'sosSelectOption--disabled': !!item.disabled === true, 'sosSelectOption--first': index === 0 }" v-html="!!item.formattedText ? item.formattedText : (item.text || '&nbsp;')")

            template(v-if="nonCheckedItems.length > 0")
              .sosSelectOption(v-for="(item, index) in nonCheckedItems" :key="`sos-select-item-${item.key}`" @mousedown="event => onSelectItem(event, item)" :class="{ 'mdi': multiple ? item.checked : (selectedItemValue === item.value), /* 'mdi-check': multiple ? item.checked : (selectedItemValue === item.value), */ 'sosSelectOption--selected': multiple ? item.checked : (selectedItemValue === item.value), 'sosSelectOption--disabled': !!item.disabled === true, 'sosSelectOption--first': index === 0 }" v-html="!!item.formattedText ? item.formattedText : (item.text || '&nbsp;')")

</template>

<script>

  const hasParentWithClass = (element, className) => {
    if (!element || !element.parentElement) return false
    if (element.parentElement.className.indexOf(className) !== -1) return true
    return hasParentWithClass(element.parentElement, className)
  }

  export default {
    name: 'SosSelect',
    props: {
      items: { type: Array, required: true },

      disabled: { type: Boolean, default: () => false },
      multiple: { type: Boolean, default: () => false }, // Novo

      autoHeight: { type: Boolean, default: () => false },

      fullscreen: { type: Boolean, default: () => false },
      fullscreenTitle: { type: String, default: () => '' },
      fullscreenAutoWidth: { type: Boolean, default: () => false },

      label: { type: String, required: true },
      labelDescription: { type: String, default: () => '' },

      default: { type: String, default: () => '' },

      defaultEmpty: { type: String, default: () => 'Selecione' },
    },

    data () {
      return {
        show: false,
      }
    },

    computed: {
      validItems ()
      {
        return typeof this.items === 'object' && Array.isArray(this.items) ? this.items : []
      },

      nonCheckedItems ()
      {
        return this.validItems.length > 0 ? this.validItems.filter(item => !!item.checked === false) : []
      },

      checkedItems ()
      {
        return this.validItems.length > 0 ? this.validItems.filter(item => !!item.checked === true) : []
      },

      checkedItemsTexts ()
      {
        return this.checkedItems.length > 0 ? this.checkedItems.map(item => !!item.rawText === true ? item.rawText : (!!item.formattedText === true ? item.formattedText : item.text)) : []
      },

      selectedItemValue ()
      {
        if (this.validItems.length === 0) return ''
        if (this.multiple === true) return ''
        if (this.default.length === 0) return ''

        const itemDefault = this.validItems.find(item => this.default === item.value)
        return itemDefault ? (!!itemDefault.value === true ? itemDefault.value : '') : ''
      },

      selectedItemText ()
      {
        if (this.validItems.length === 0) return this.defaultEmpty
        if (this.multiple === true) return this.checkedItemsTexts.length === 1 ? this.checkedItemsTexts[0] : (this.checkedItemsTexts.length === 0 ? this.defaultEmpty : `(${this.checkedItemsTexts.length}) ${this.checkedItemsTexts.join(', ')}`)
        if (this.default.length === 0) return this.defaultEmpty

        const itemDefault = this.validItems.find(item => this.default === item.value)
        return itemDefault ? (!!itemDefault.formattedText === true ? itemDefault.formattedText : itemDefault.text) : this.defaultEmpty
      },
    },

    watch: {
      default: {
        immediate: true,
        handler (defaultNew, defaultOld)
        {
          if (typeof defaultNew === 'string' && this.multiple === false) this.default = defaultNew

          /* if (typeof defaultNew === 'string') {
            this.default = defaultNew
            this.refreshProps()
          } */
        },
      },

      /* items: {
        immediate: true,
        handler (defaultNew, defaultOld)
        {
          const oldOptions = typeof defaultOld === 'object' && Array.isArray(defaultOld) ? defaultOld : []
          const newOptions = typeof defaultNew === 'object' && Array.isArray(defaultNew) ? defaultNew : []

          if (oldOptions.length === 0 && newOptions.length > 0) {
            this.refreshProps()
          }
        },
      }, */
    },

    mounted () {
      document.addEventListener('mousedown', this.close)
    },

    beforeDestroy () {
      document.removeEventListener('mousedown', this.close)
    },

    //
    // JESUS
    //
    // 10/05/24
    //
    // testar no celular
    // testar no celular
    // testar no celular
    //

    methods: {
      //
      //
      //

      openMouse (event)
      {
        if (this.disabled) return false

        const hasScales = !!this.validItems === true && this.validItems.length > 0
        if (!hasScales) return false

        if (!!event.target === false) return false
        if (!!event.target.className === false) return false

        const hasParent = !!event.target.parentElement === true && (event.target.parentElement.className.indexOf('sosSelectOption') !== -1 || hasParentWithClass(event.target, 'sosSelectOption'))

        // if (event.which !== 1) return false
        if (event.target.className.indexOf('sosSelectOptions') !== -1) return false // Desconsidera se o usuário clicou na rolagem

        if (event.target.className.indexOf('sosSelectOption') !== -1 || hasParent) return false // Desconsidera se o usuário clicou em uma opção

        this.show = true
      },

      //
      //
      //

      instantClosing ()
      {
        this.show = false
      },

      close (event)
      {
        // Correção de uma mensagem de erro no INSPETOR DE OBJETOS ddo Chrome (contains...)
        if (!this.show) return false

        // Verifique se o clique ocorreu fora do componente e das opções
        if (!this.$refs.sosSelect.contains(event.target) && !this.$refs.sosSelectOptions.contains(event.target))
        {
          this.instantClosing()
        }
      },

      //
      //
      //

      /* refreshProps ()
      {
        const defaultItem = this.items.find(item => String(this.default || '') === String(item.value || '')) || null

        this.selectedItemValue = defaultItem && defaultItem.value ? defaultItem.value : ''
        this.selectedItemText = defaultItem ? (defaultItem.formattedText || defaultItem.text) : 'Selecione'
      }, */

      //
      //
      //

      // onSelectItem (event, index)
      //   const item = this.validItems[index] || null
      //   if (!!item.value === true && item.value !== this.selectedItemValue)

      onSelectItem (event, item)
      {
        // Prevenção de bugs
        if (!!item === false) return false

        // Item desabilitado, então para o processamento aqui
        if (!!item.disabled === true) return false

        this.instantClosing()

        if (
          // JESUS: Detectar valor vazio
          Object.prototype.hasOwnProperty.call(item, 'value') &&
          (
            this.multiple ||
            item.value !== this.selectedItemValue
          )
        ) {
          this.$emit('sosSelectChanged', item.value, item.text || '', item.payload || null)
        }
      },
    },
  }

</script>
